import PropTypes from "prop-types"
import React from "react"
import * as style from "./splitview.module.scss"

const SplitView = ({ image, spacing, children, wrapStyle, splitStyle }) => (
  <div className={style.SplitView}>
    <div
      className={
        wrapStyle === "default"
          ? style.splitWrapper
          : style.splitWrapperReverse
      }
    >
      <div
        className={style.imageSplit}
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: `cover`,
          backgroundPosition: `center center`,
          padding: `${spacing}`,
        }}
      ></div>
      <div
        className={
          splitStyle === "default"
            ? style.contentSplit
            : style.contentSplitGrey
        }
        style={{ padding: `${spacing}` }}
      >
        {children}
      </div>
    </div>
  </div>
)

SplitView.propTypes = {
  image: PropTypes.string,
  children: PropTypes.any,
  spacing: PropTypes.string,
  wrapStyle: PropTypes.oneOf(["default", "reverse"]),
  splitStyle: PropTypes.oneOf(["default", "grey"]),
}

SplitView.defaultProps = {
  image: ``,
  wrapStyle: `default`,
  splitStyle: `default`,
  spacing: `5vw`,
}

export default SplitView